// useLock — multi-user lock pre editaciu zdielanych entit (sek. Partneri lock)
// Port zo stareho frontendu (App.jsx r.59) s pouzitim fetchAuth (Bearer token).
//
// Backend: /api/locks/{acquire, heartbeat, release, check}
// Heartbeat kazdych 55s (lock expiruje za 60s na backende).
//
// API:
//   const { lockInfo, acquired, release } = useLock('customer', 'K123', user)
//   lockInfo = null pri acquired=true, alebo { by: 'username' } ak zamknul iny
//   acquired = boolean
//   release() — explicit unlock (pri zatvarani edit modal)

import { useState, useEffect, useRef, useCallback } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'

export function useLock(resource, id, user) {
  const [lockInfo, setLockInfo] = useState(null)
  const [acquired, setAcquired] = useState(false)
  const hbRef = useRef(null)
  const username = user?.username
  const displayName = user?.display_name || user?.username

  useEffect(() => {
    if (!resource || !id || !username) return
    let cancelled = false

    const acquire = async () => {
      try {
        const r = await fetchAuth('/api/locks/acquire', {
          method: 'POST',
          body: JSON.stringify({ resource, id: String(id), username, displayName })
        })
        const d = await r.json()
        if (cancelled) return
        if (d.acquired) {
          setAcquired(true)
          setLockInfo(null)
          hbRef.current = setInterval(() => {
            fetchAuth('/api/locks/heartbeat', {
              method: 'POST',
              body: JSON.stringify({ resource, id: String(id), username })
            }).catch(() => {})
          }, 55_000)
        } else {
          setLockInfo({ by: d.by || '?' })
          setAcquired(false)
        }
      } catch (_) {}
    }

    acquire()

    return () => {
      cancelled = true
      if (hbRef.current) clearInterval(hbRef.current)
      // Pri unmount uvolnit (fire-and-forget)
      fetchAuth('/api/locks/release', {
        method: 'POST',
        body: JSON.stringify({ resource, id: String(id), username })
      }).catch(() => {})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resource, id, username])

  const release = useCallback(() => {
    if (hbRef.current) { clearInterval(hbRef.current); hbRef.current = null }
    fetchAuth('/api/locks/release', {
      method: 'POST',
      body: JSON.stringify({ resource, id: String(id), username })
    }).catch(() => {})
    setAcquired(false)
    setLockInfo(null)
  }, [resource, id, username])

  return { lockInfo, acquired, release }
}

export default useLock
